import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';

export const essTourGeneralQuizLayout: Record<
  EssTopic,
  { sections: Array<EssSection> }
> = {
  [EssTopic.PARITY_EQUALITY]: {
    sections: [
      EssSection.ARTISTIC_TEAM,
      EssSection.PERMANENT_PRODUCTION_TEAM,
      EssSection.OCCASIONAL_OPERATIONAL_TEAM,
      EssSection.TRANSPARENCY_MANAGEMENT,
    ],
  },
  [EssTopic.ACCESSIBILITY_SOCIAL_DIALOGUE]: {
    sections: [
      EssSection.ACCESSIBILITY,
      EssSection.RISK_PREVENTION,
      EssSection.TEAM_MANAGEMENT,
    ],
  },
  [EssTopic.LOCAL_IMPACT_RSE_ENGAGEMENT]: {
    sections: [EssSection.ECONOMIC_SOCIAL_IMPACT],
  },
};
